import "@hotwired/turbo-rails";
import "chartkick/chart.js";

import * as ActiveStorage from "@rails/activestorage";
import "./controllers";
import "./components/direct_uploads";
import "./components/analytics";
import "./components/posthog";

ActiveStorage.start();

document.addEventListener("turbo:visit", () => {
  const location = Turbo.navigator.currentVisit?.location;
  const anchor = location?.searchParams.get("_anchor");
  if (anchor) {
    location.searchParams.delete("_anchor");
    location.hash = anchor;
  }
});
